// extracted by mini-css-extract-plugin
export default {"answer-flexbox":"style_answer-flexbox__NBg76"};